import { render, staticRenderFns } from "./editAssessmentSet.vue?vue&type=template&id=46f84996&scoped=true&"
import script from "./editAssessmentSet.vue?vue&type=script&lang=js&"
export * from "./editAssessmentSet.vue?vue&type=script&lang=js&"
import style0 from "./editAssessmentSet.vue?vue&type=style&index=0&id=46f84996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f84996",
  null
  
)

export default component.exports